import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import projectQueries from "../../../requests/queries/ProjectsQuesries";
import ConfirmationModal from "../../common/ConfirmationModal";
import "./projectsList.css";

export default function ProjectsList() {
    const [search, setSearch] = useState('');
    const [projects, setProjects] = useState([]);
    const [projectToDelete, setProjectToDelete] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getProjects();
    }, []);

    const getProjects = async () => {
        setIsLoading(true);
        try {
            const projects = await projectQueries.getProjects();
            setProjects(projects);
        } finally {
            setIsLoading(false);
        }
    };

    const filteredProjects = projects.filter((project) => 
        project.name.toLowerCase().includes(search.toLowerCase())
    );

    const handleDelete = async () => {
        if (projectToDelete) {
            await projectQueries.deleteProject(projectToDelete.id);
            getProjects();
            setProjectToDelete(null);
        }
    };

    return (
        <div className="projects-page">
            <div className="projects-container">
                {/* Header */}
                <header className="projects-header">
                    <div className="projects-header-top">
                        <div className="projects-title-group">
                            <h1 className="projects-title">
                                <span className="projects-title-icon">📁</span>
                                Mes Projets
                            </h1>
                            <p className="projects-subtitle">
                                Gérez et organisez vos projets de bornes interactives
                            </p>
                        </div>
                        
                        <div className="projects-header-actions">
                            <Link to="/projects/create" className="projects-create-btn">
                                <span>✨</span>
                                Nouveau projet
                            </Link>
                            <Link to="/devices" className="nav-link-btn">
                                <span>📱</span>
                                Devices
                            </Link>
                            <Link to="/settings" className="nav-link-btn">
                                <span>⚙️</span>
                                Paramètres
                            </Link>
                        </div>
                    </div>

                    {/* Stats */}
                    <div className="projects-stats">
                        <div className="projects-stat">
                            <span className="projects-stat-icon">📊</span>
                            <span className="projects-stat-value">{projects.length}</span>
                            <span className="projects-stat-label">projet{projects.length > 1 ? 's' : ''}</span>
                        </div>
                    </div>

                    {/* Recherche */}
                    <div className="projects-search-bar">
                        <input
                            type="text"
                            className="projects-search-input"
                            placeholder="Rechercher un projet..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <span className="projects-search-icon">🔍</span>
                    </div>
                </header>

                {/* Grille de projets */}
                {!isLoading && filteredProjects.length > 0 && (
                    <div className="projects-grid">
                        {filteredProjects.map((project) => (
                            <article key={project.id} className="project-card">
                                <div className="project-card-accent"></div>
                                <div className="project-card-content">
                                    <div className="project-card-header">
                                        <div className="project-card-icon">🖥️</div>
                                    </div>
                                    
                                    <h2 className="project-card-title">{project.name}</h2>
                                    <p className="project-card-description">
                                        {project.description || "Aucune description"}
                                    </p>
                                    
                                    <div className="project-card-meta">
                                        <div className="project-card-meta-item">
                                            <span className="project-card-meta-icon">📅</span>
                                            {new Date(project.created_at).toLocaleDateString('fr-FR', {
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                            })}
                                        </div>
                                        {project.screen_size && (
                                            <div className="project-card-meta-item">
                                                <span className="project-card-meta-icon">📐</span>
                                                {project.screen_size.width}×{project.screen_size.height}
                                            </div>
                                        )}
                                    </div>

                                    <div className="project-card-actions">
                                        <Link 
                                            to={`/project/${project.id}`} 
                                            className="project-card-btn project-card-btn-view"
                                        >
                                            Ouvrir →
                                        </Link>
                                        <button
                                            className="project-card-btn project-card-btn-delete"
                                            onClick={() => setProjectToDelete(project)}
                                        >
                                            🗑️
                                        </button>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                )}

                {/* État vide */}
                {!isLoading && filteredProjects.length === 0 && (
                    <div className="projects-empty">
                        <div className="projects-empty-icon">📭</div>
                        <h2 className="projects-empty-title">
                            {search ? 'Aucun résultat' : 'Aucun projet'}
                        </h2>
                        <p className="projects-empty-text">
                            {search 
                                ? `Aucun projet ne correspond à "${search}"`
                                : 'Commencez par créer votre premier projet de borne interactive'
                            }
                        </p>
                        {!search && (
                            <Link to="/projects/create" className="projects-create-btn">
                                <span>✨</span>
                                Créer mon premier projet
                            </Link>
                        )}
                    </div>
                )}

                {/* Modal de confirmation */}
                {projectToDelete && (
                    <ConfirmationModal
                        title="Supprimer le projet ?"
                        icon="🗑️"
                        iconType="danger"
                        confirmText="Supprimer"
                        cancelText="Annuler"
                        onConfirm={handleDelete}
                        onCancel={() => setProjectToDelete(null)}
                    >
                        Êtes-vous sûr de vouloir supprimer <strong>"{projectToDelete.name}"</strong> ? 
                        Cette action est irréversible.
                    </ConfirmationModal>
                )}
            </div>
        </div>
    );
}
